module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(_vm.track) ? _c('v-flex', [_c('h1', {
    staticClass: "display-1"
  }, [_vm._v("Edit Track")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.track.name) + "\n            "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogName = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.track.artist) + "\n            "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogArtist = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('dialog-name', {
    attrs: {
      "track": _vm.track
    },
    model: {
      value: (_vm.dialogName),
      callback: function($$v) {
        _vm.dialogName = $$v
      },
      expression: "dialogName"
    }
  }), _vm._v(" "), _c('dialog-artist', {
    attrs: {
      "track": _vm.track
    },
    model: {
      value: (_vm.dialogArtist),
      callback: function($$v) {
        _vm.dialogArtist = $$v
      },
      expression: "dialogArtist"
    }
  }), _vm._v(" "), _c('dialog-source', {
    attrs: {
      "track": _vm.track
    },
    model: {
      value: (_vm.dialogSource),
      callback: function($$v) {
        _vm.dialogSource = $$v
      },
      expression: "dialogSource"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-745528be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageTrackEdit.vue
// module id = 383
// module chunks = 0